import { dictEnStep1 } from '../steps/01_preparations/translation/dictEnStep1';
import { dictEnStep2 } from '../steps/02_shipment-details/translation/dictEnStep2';

export const dictEn = {
  ...dictEnStep1,
  ...dictEnStep2,
  Edit: 'Edit',
  Delete: 'Delete',
  Next: 'Next',
  Close: 'Close',
  Required: 'required',
  NotCorrectEmail: 'not correct email',
  NotCorrectPhone: 'not correct phone',
  NotCorrectINN: 'not correct inn',
  NotCorrectKPP: 'not correct kpp',
  NotCorrectDeliveryTypeText: 'The description must be detailed and specified in English!',
  minTextLength: 'minimum {number} symbols',
  maxTextLength: 'maximum {number} symbols',
  LatinOnly: 'Only the Latin alphabet is allowed',
  CyrillicOnly: 'Only the Cyrillic alphabet is allowed',
  LatinOnlyPopup: 'The sender is a foreigner. Enter its details in English.',
  Error: 'Sorry, an error occur',
  notRequired: 'This field is optional',
  IataCodeErrorTitle: 'Dear customer',
  IataCodeErrorText: '<p>Transit time and cost quotations are not available for the origin or destination you provided till the 12th of Jan 2020 due to maintenance.</p><p> We kindly ask you to contact our call center <span>[!phone!]</span> for the quotation and arranging the pick-up.</p><p> Please accept our apologies for any inconvenience it caused.</p><p>DHL Team.</p>',
  ConfirmModalYes: 'Yes',
  ConfirmModalNo: 'No',
  BoxAttentionText: 'Attention! The packaging must be strong, reliable and protect the cargo from damage. The size of the package should allow you to place a 15x21 cm invoice on one of the sides.',
  MarketingNewsletterAllowed: 'Consent to the distribution of distributed materials.',
  Invoice: 'Invoice',
  MarketingNewsletterAllowed: 'Consent to the distribution of distributed materials.',
};

export default {
  dictEn,
};
